module.exports = __webpack_public_path__ + "img/placeholder.dbe35130.jpg";